import SignInClassicContainer from "../../../Components/Authentication/SignInClassic";

const SignInClassic = () => {
  return <SignInClassicContainer />;
};

export default SignInClassic;
